import { version } from '@/../package.json';

// app version
export const VERSION = version;

// local config
export * from './local';
